__turbopack_context__.v({
  "heading": "Heading-module__5apIFW__heading",
  "headingBreakWords": "Heading-module__5apIFW__headingBreakWords",
  "headingLineClamp": "Heading-module__5apIFW__headingLineClamp",
  "headingLineClamp1": "Heading-module__5apIFW__headingLineClamp1",
  "headingLineClamp2": "Heading-module__5apIFW__headingLineClamp2",
  "headingLineClamp3": "Heading-module__5apIFW__headingLineClamp3",
  "headingSameLine": "Heading-module__5apIFW__headingSameLine",
});
